export class BannerModel {
  base64: string;
  url: string;
  constructor(base64: string, url: string) {
    this.base64 = base64;
    this.url = url;
  }
}
